import {
  pageInfo,
  exportData,
  customerEditInit,
  customerSave,
  customerDelete
} from './../api';
const distributor = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initObj: null,
    exportObj: null,
    customerSubmitObj: null,
    deleteObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },

    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data){
      state.exportObj = data;
    },
    /**
     * 编辑初始化
     * @param state
     * @param data
     * @constructor
     */
    CUSTOMER_EDIT_INIT(state, data){
      state.initObj = data;
    },
    /**
     * 保存
     * @param state
     * @param data
     * @constructor
     */
    CUSTOMER_SAVE(state, data){
      state.customerSubmitObj = data;
    },
    /**
     * 删除
     * @param state
     * @param data
     * @constructor
     */
    CUSTOMER_DELETE(state, data){
      state.deleteObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    /**
     * 编辑初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async customerEditInit({commit}, obj) {
      let resp = await customerEditInit(obj);
      commit('CUSTOMER_EDIT_INIT', resp);
    },
    /**
     * 保存
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async customerSave({commit}, obj) {
      let resp = await customerSave(obj);
      commit('CUSTOMER_SAVE', resp);
    },
    /**
     * 删除
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async customerDelete({commit}, obj) {
      let resp = await customerDelete(obj);
      commit('CUSTOMER_DELETE', resp);
    },
  }
}
export default distributor



// WEBPACK FOOTER //
// ./src/page/md/distributor/store/distributor.store.js